//Get the Model prototype
var modelProto = require('derby').constructor.prototype.Model.prototype;
	//TODO get Query prototype in a cleaner way
	Query = require('derby/node_modules/racer/lib/Model/Query'),
	queryProto = Query.prototype;

if (typeof Promise === 'undefined') {
	//use rsvp promise if native promises are not available
	var rsvp = require('rsvp');
	var Promise = rsvp.Promise;
	//prevent uncaught errors in promises from failing silently
	rsvp.on('error', function onError(err) {
		console.error(err);
	});
}

//How this works:
//In each of the overridden functions, we first check for a callback as the last argument
//and if we find one, then we delegate to the original Derby method.
//Otherwise, we return a promise. This part is similar in concept to rsvp.denodeify()
//(it's also similar to Bluebird's promisify() function) but it's tailored specifically
//for the Racer methods.

//TODO
//Test that both forms of subscribe() and fetch() work:
/*
 From racer/lib/Model/subscriptions.js:
 
 * @param {Arguments} argumentsObject can take 1 of two forms
 *   1. [[subscribableObjects...], cb]
 *   2. [subscribableObjects..., cb]
*/

[modelProto, queryProto].forEach(function(proto) {
	['fetch', 'subscribe'].forEach(function(fnName) {
		var origFn = proto[fnName];
		proto[fnName] = function() {
			//if a callback was supplied (as the last argument), use the original Derby function
			if (typeof arguments[arguments.length-1] === 'function') {
				return origFn.apply(this, arguments);
			}
		
			var self = this,
				args = Array.prototype.slice.call(arguments);
			return new Promise(function(resolve, reject) {
				var callback  = function(err) {
					if (err) reject(err);
					else resolve();
				}
				args.push(callback);
				origFn.apply(self, args);
			});
		}
	});
});

//TODO: fetchGet() and subscribeGet() with multiple arguments,
//e.g. model.fetchGet(query1, query2).then(function(results: Array<Array>) {...})

//Convenience method: fetch() followed by get()
modelProto.fetchGet = function fetchGet() {
	var firstArg = arguments[0],
		self = this;
	return self.fetch.apply(self, arguments).then(function() {
		return (firstArg instanceof Query ? firstArg.get(): self.get(firstArg));
	});
};

//Convenience method: fetch() followed by get()
queryProto.fetchGet = function fetchGet() {
	var firstArg = arguments[0],
		self = this;
	return self.fetch.apply(self, arguments).then(function() {
		return self.get(firstArg);
	});
};

//TODO
//Do we need subscribeGet? It would only be useful if it gets called again if the
//results change, and that's not how promises work (is it possible for them to work that way?)

//There is deliberately no query.subscribeGet() method, because it would be effectively
//no different from query.fetchGet().

//Convenience method: subscribe() followed by get()
modelProto.subscribeGet = function subscribeGet() {
	var firstArg = arguments[0],
		self = this;
	return self.subscribe.apply(self, arguments).then(function() {
		//Note: if firstArg is a Query, then this would be the same as calling fetchGet().
		return (firstArg instanceof Query ? firstArg.get(): self.get(firstArg));
	});
};

var origSet = modelProto.set;
modelProto.set = function set(arg1, arg2) {
	if (arguments.length === 3) {
		return origSet.apply(this, arguments);
	}
	
	var self = this,
		args = Array.prototype.slice.call(arguments);
	return new Promise(function(resolve, reject) {
		var callback  = function(err) {
			if (err) reject(err);
			else resolve();
		}
		origSet.call(self, arg1, arg2, callback);
	});
};

//Commenting; this doesn't work correctly.
//Ordinarily, add() synchronously returns the ID of the newly created object.
//We don't want to break code that relies on that, and the callback parameter is optional,
//so we can't just check for a callback.
//Possible workarounds:
// - a separate method that returns a promise, e.g. model.addPromise()
// - an argument indicating that it should return a promise, e.g. model.add(collection, obj, shouldReturnPromise);
/*
var origAdd = modelProto.add;
modelProto.add = function add(arg1, arg2) {
	if (arguments.length === 3) {
		return origAdd.apply(this, arguments);
	}
	
	var self = this,
		args = Array.prototype.slice.call(arguments);
	return new Promise(function(resolve, reject) {
		var insertedId;
		var callback = function(err) {
			if (err) reject(err);
			else resolve(insertedId);
		}
		insertedId = origAdd.call(self, arg1, arg2, callback);
	});
};
*/

var origDel = modelProto.del;
modelProto.del = function del(path, cb) {
	if (typeof cb === 'function' || (arguments.length==0 && typeof arguments[0] === 'function')) {
		return origDel.call(this, path, cb);
	}
	
	var self = this;
	return new Promise(function(resolve, reject) {
		var callback = function(err) {
			if (err) reject(err);
			else resolve(self);
		}
		origDel.call(self, path, callback);
	});
};
